"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateBetslipOddsByBet = exports.getMissingMatches = exports.setInitialBetslip = exports.deleteBetslipBet = exports.placeBet = exports.createBet = exports.addBetslipBet = exports.adoptionUnaffectedBetslipOdds = exports.changeBetslipBetStake = exports.changeBetslipOddStake = exports.deleteBetslipOdd = exports.addBetslipOdd = exports.toggleSystemCombination = exports.choseBetslipBetId = exports.deleteBetslipOdds = exports.changeOddUpdateStatus = exports.changeBetslipMode = void 0;
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
var immutable_1 = require("immutable");
var lodash_1 = require("lodash");
var core_1 = __importStar(require("@gin-betting/core"));
var selectors_1 = require("./selectors");
var utils_1 = require("./utils");
var constants_1 = require("./constants");
var _a = core_1.default.utils, getIdsFromBetslipOddId = _a.getIdsFromBetslipOddId, getBettingOptions = _a.getBettingOptions, makeAction = _a.makeAction, _b = core_1.default.entities, makeGetMissingMatches = _b.actions.makeGetMissingMatches, selectOdds = _b.selectors.selectOdds;
function changeBetslipMode(payload) {
    return makeAction(constants_1.CHANGE_BET_MODE, payload);
}
exports.changeBetslipMode = changeBetslipMode;
function changeOddUpdateStatus(payload) {
    return makeAction(constants_1.CHANGE_COEF_UPDATES, payload);
}
exports.changeOddUpdateStatus = changeOddUpdateStatus;
function deleteBetslipOdds(payload) {
    return makeAction(constants_1.DELETE_BETSLIP_ODDS, payload);
}
exports.deleteBetslipOdds = deleteBetslipOdds;
function choseBetslipBetId(payload) {
    return makeAction(constants_1.CHOSE_BETSLIP_BET_ID, payload);
}
exports.choseBetslipBetId = choseBetslipBetId;
function toggleSystemCombination(payload) {
    return makeAction(constants_1.TOGGLE_SYSTEM_COMBINATION, payload);
}
exports.toggleSystemCombination = toggleSystemCombination;
function addBetslipOdd(payload) {
    return makeAction(constants_1.ADD_BETSLIP_ODD, payload);
}
exports.addBetslipOdd = addBetslipOdd;
function deleteBetslipOdd(payload) {
    return makeAction(constants_1.DELETE_BETSLIP_ODD, payload);
}
exports.deleteBetslipOdd = deleteBetslipOdd;
function changeBetslipOddStake(payload) {
    return makeAction(constants_1.CHANGE_BETSLIP_ODD_STAKE, payload);
}
exports.changeBetslipOddStake = changeBetslipOddStake;
function changeBetslipBetStake(payload) {
    return makeAction(constants_1.CHANGE_BETSLIP_BET_STAKE, payload);
}
exports.changeBetslipBetStake = changeBetslipBetStake;
function adoptionUnaffectedBetslipOdds(payload) {
    return makeAction(constants_1.ADOPT_UNAFFECTED_BETSLIP_ODDS, payload);
}
exports.adoptionUnaffectedBetslipOdds = adoptionUnaffectedBetslipOdds;
function addBetslipBet() {
    return makeAction(constants_1.ADD_BETSLIP_BET);
}
exports.addBetslipBet = addBetslipBet;
function createBet(payload) {
    return {
        type: constants_1.CREATE_BETS_REQUEST,
        payload: __assign({ method: 'placeBet' }, payload),
        meta: {
            isApiCall: true,
            skipBatching: true,
        },
    };
}
exports.createBet = createBet;
function placeBet(_a) {
    var inputUnaffectedBetslipOddIds = _a.unaffectedBetslipOddIds, meta = _a.meta, stakeMode = _a.stakeMode;
    return function (dispatch, getState) {
        var state = getState();
        var betslipBet = selectors_1.selectChosenBetslipBet(state);
        if (!betslipBet) {
            console.warn("Can't find betslipBet. BetslipBetId: " + state.betslip.chosenBetslipBetId + " from state");
            return;
        }
        var oddAcceptStrategy = selectors_1.selectOddUpdateStatus(state);
        var odds = selectOdds(state);
        var currency = getBettingOptions().currency;
        var betslipBetId = betslipBet.id, mode = betslipBet.mode, betslipOddIds = betslipBet.betslipOddIds;
        var betslipOdds = selectors_1.selectBetslipOddsByBetslipBetId(state, {
            betslipBetId: betslipBetId,
        });
        var status = utils_1.getStatus({ betslipOddIds: betslipOddIds, betslipOdds: betslipOdds });
        var isInitial = status === core_1.App.BetslipStatus.INITIAL;
        if (isInitial) {
            dispatch(addBetslipBet());
        }
        switch (mode) {
            case core_1.GQL.BetType.SINGLE: {
                var unaffectedBetslipOddIds_1 = __spreadArray([], inputUnaffectedBetslipOddIds);
                var affectedBetslipOdds = betslipOdds.filter(function (_a) {
                    var betslipOddId = _a.id, singleStake = _a.singleStake, singleStatus = _a.singleStatus;
                    var isAffected = !unaffectedBetslipOddIds_1.includes(betslipOddId);
                    if (isAffected &&
                        (+singleStake <= 0 ||
                            !lodash_1.includes(constants_1.BETSLIP_ODD_STATUSES_TO_PLACE_BET, singleStatus))) {
                        isAffected = false;
                        unaffectedBetslipOddIds_1.push(betslipOddId);
                    }
                    return isAffected;
                });
                affectedBetslipOdds.forEach(function (betslipOdd) {
                    var oddId = getIdsFromBetslipOddId(betslipOdd.id).oddId;
                    var odd = odds.get(oddId);
                    if (odd) {
                        var newBet = __assign(__assign({}, betslipOdd), { oddRatio: odd.value });
                        var variables = utils_1.composeBet({
                            currencyCode: currency,
                            stake: +betslipOdd.singleStake,
                            newBets: [newBet],
                            type: mode,
                            oddAcceptStrategy: oddAcceptStrategy,
                            meta: meta,
                            stakeMode: stakeMode,
                        });
                        var args = {
                            betslipBetId: betslipBet.id,
                            betslipOddIds: immutable_1.OrderedSet([betslipOdd.id]),
                        };
                        dispatch(createBet({ variables: variables, args: args }));
                    }
                    else {
                        console.warn("Can't find odd. OddId: " + oddId + " from BetslipOddId");
                        dispatch(deleteBetslipOdd({ betslipBetId: betslipBetId, oddId: oddId }));
                    }
                });
                break;
            }
            case core_1.GQL.BetType.EXPRESS:
            case core_1.GQL.BetType.SYSTEM: {
                var newBets_1 = [];
                var isValid = betslipOdds.every(function (betslipOdd) {
                    var oddId = getIdsFromBetslipOddId(betslipOdd.id).oddId;
                    var odd = odds.get(oddId);
                    if (odd) {
                        newBets_1.push(__assign(__assign({}, betslipOdd), { oddRatio: odd.value }));
                        return true;
                    }
                    console.warn("Can't find odd. OddId: " + oddId + " from BetslipOddId");
                    return false;
                });
                if (isValid) {
                    var variables = utils_1.composeBet({
                        stake: +betslipBet.stake,
                        type: mode,
                        currencyCode: currency,
                        newBets: newBets_1,
                        systemSize: betslipBet.systemSize,
                        oddAcceptStrategy: oddAcceptStrategy,
                        meta: meta,
                        stakeMode: stakeMode,
                    });
                    var args = {
                        betslipBetId: betslipBet.id,
                        betslipOddIds: betslipOddIds,
                    };
                    dispatch(createBet({ variables: variables, args: args }));
                }
                break;
            }
            default:
                break;
        }
    };
}
exports.placeBet = placeBet;
function deleteBetslipBet(payload) {
    return makeAction(constants_1.DELETE_BETSLIP_BET, payload);
}
exports.deleteBetslipBet = deleteBetslipBet;
function setInitialBetslip(payload) {
    return makeAction(constants_1.SET_INITIAL_BETSLIP, payload);
}
exports.setInitialBetslip = setInitialBetslip;
exports.getMissingMatches = makeGetMissingMatches({
    type: constants_1.GET_MISSING_MATCHES_REQUEST,
    withMarketsCount: false,
});
function updateBetslipOddsByBet(payload) {
    return makeAction(constants_1.UPDATE_BETSLIP_ODDS_BY_BET, payload);
}
exports.updateBetslipOddsByBet = updateBetslipOddsByBet;
//# sourceMappingURL=actions.js.map